import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { map, startWith, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ProjectService } from '@service/project.service';
import { AuthService } from '@service/auth.service';
import { Events } from '@service/events.service';
import { RepositoriesService } from '@service/repositories.service';

import { Paginate } from '@model/Paginate';
import { Project } from '@model/Project';
import { Repository } from '@model/Repository';
import { ModalRepositoryComponent } from '@component/modal-repository/modal-repository.component';

@Component({
  selector: 'app-my-students',
  templateUrl: './my-students.component.html',
  styleUrls: ['./my-students.component.scss'],
})
export class MyStudentsComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('searchInput', { read: ElementRef, static: false }) searchInput: ElementRef;

  term: string = '';
  public pageEvent: PageEvent;
  public page: Paginate<Project> = {
    page: 20,
    current: 0,
    total: 0
  } as Paginate<Project>;
  public pageSizeOptions: number[] = [5, 10, 20];
  projects: Paginate<Project> = null;
  repositories: Paginate<Repository> = null;
  loading: boolean = true;
  isFolder = true;
  filter: string = null;
  searchFieldPlaceholder = 'pasta';

  private subscription = new Subscription();

  modalRepositoryOptions: NgbModalOptions;

  constructor(
    private authService: AuthService,
    private projectService: ProjectService,
    private readonly repositoriesService: RepositoriesService,
    private readonly events: Events,
    private readonly modalService: NgbModal
  ) {
    this.modalRepositoryOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    };
  }

  ngOnInit() {
    // this.pageEvent = this.getData({ previousPageIndex: 0, pageIndex: this.page.current, pageSize: this.page.page, length: this.page.total });
    this.pageEvent = this.getData({ previousPageIndex: 0, pageIndex: this.page.current, pageSize: this.page.page, length: this.page.total });

    this.authService.removeInvitationRole();

    this.events.on('leaveProject').subscribe(() => {
      this.pageEvent = this.getData({ previousPageIndex: 0, pageIndex: 0, pageSize: 20, length: 0 });
    });

    this.events.on('deleteRepository').subscribe((id: number) => {
      const index = this.position(id);

      if (index > -1) {
        this.repositories.data.splice(index, 1);
      }
    });

    this.events.on('editRepositorySuccess').subscribe(() => this.pageEvent = this.getData({ previousPageIndex: 0, pageIndex: 0, pageSize: 20, length: 0 }));
  }

  ngAfterViewInit() {
    this.search();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private search() {
    const term$ = fromEvent(this.searchInput.nativeElement, 'keyup')
      .pipe(
        map((event: any) => event.target.value),
        startWith(''),
        debounceTime(400),
        distinctUntilChanged()
      );

    this.subscription.add(
      term$.subscribe(
        term => {
          this.term = term;
          this.getData(this.pageEvent);
        }
      )
    );
  }

  private position(id: number): number {
    return this.repositories.data.map(el => el.id).indexOf(id);
  }

  // getData(event?: PageEvent): PageEvent {
  //   this.projectService.paginateStudentsProjects(event.pageSize, event.pageIndex + 1, this.term)
  //   .subscribe((projects: Paginate<Project>) => {
  //     this.page = {...this.page, total: projects.total};
  //     this.projects = projects;

  //     projects.data.forEach((project, index) => {
  //       const percentage = this.projectService.calcPercentage(project.progress.cycles);
  //       projects.data[index].percentage = percentage;
  //     });
  //     this.loading = false;
  //   }, () => this.loading = false);
  //   return event;
  // }

  getData(event?: PageEvent): PageEvent {
    this.repositoriesService.getRepositories(event.pageSize, event.pageIndex + 1, this.filter, this.term, false)
      .subscribe((repositories: Paginate<Repository>) => {
        this.page = {...this.page, total: repositories.total};
        this.repositories = repositories;
        this.loading = false;
      }, () => this.loading = false);
    return event;
  }

  newRepository() {
    const modal = this.modalService.open(ModalRepositoryComponent, this.modalRepositoryOptions);
    modal.componentInstance.isAuthor = false;
    modal.result.then((repository = null) => {
      if (repository) {
        this.repositories.total += 1;
        this.pageEvent = this.getData({ previousPageIndex: 0, pageIndex: 0, pageSize: 20, length: 0 });
      }
    });
  }

  public get isRepositoriesEmpty(): boolean {
    return this.repositories === null || this.repositories.data.length === 0;
  }

  getFilterValue(filter: string, isFolder) {
    this.isFolder = isFolder;
    this.filter = filter;

    switch (filter) {
      case 'Author':
        this.searchFieldPlaceholder = 'autor';
        break;
      case 'Title':
        this.searchFieldPlaceholder = 'título';
        break;
      default:
        this.searchFieldPlaceholder = 'pasta';
        break;
    }

    this.pageEvent = this.getData({
      previousPageIndex: 0,
      pageIndex: 0,
      pageSize: 20,
      length: 0,
    });
  }
}
